/**
 * Single source of truth for menu state, written only by `useMenu` and read
 * by other consumers (rails, grid, search, ...) instead of each
 * re-deriving/threading its own copy through Context.
 */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface IMenuState {
  collapse: boolean;
  display: boolean;
  resetIndexToken: number;
}

const initialState: IMenuState = {
  collapse: true,
  display: false,
  resetIndexToken: 0,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setMenuCollapse: (state, action: PayloadAction<boolean>) => {
      state.collapse = action.payload;
    },
    setMenuDisplay: (state, action: PayloadAction<boolean>) => {
      state.display = action.payload;
    },
    resetMenuListIndex: (state) => {
      state.resetIndexToken += 1;
    },
  },
});

export const { setMenuCollapse, setMenuDisplay, resetMenuListIndex } =
  menuSlice.actions;
export const selectMenuCollapse = (state: RootState) => state.menu.collapse;
export const selectMenuDisplay = (state: RootState) => state.menu.display;
export const selectMenuResetIndexToken = (state: RootState) =>
  state.menu.resetIndexToken;
export default menuSlice.reducer;
